import React from 'react';
import { Bell, Menu } from 'lucide-react';
import { useSidebar } from '../contexts/SidebarContext';
export function Topbar() {
  const {
    setIsMobileMenuOpen
  } = useSidebar();
  return <div className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 sm:px-6 gap-4" data-id="element-195">
      <button onClick={() => setIsMobileMenuOpen(true)} className="md:hidden p-2 hover:bg-gray-100 transition-colors rounded-full" data-id="element-196">
        <Menu className="w-5 h-5 text-gray-600" data-id="element-197" />
      </button>
      <div className="flex-1" data-id="element-198" />
      <div className="flex items-center gap-3" data-id="element-199">
        <button className="p-2 hover:bg-gray-100 transition-colors rounded-full" data-id="element-200">
          <Bell className="w-5 h-5 text-gray-600" data-id="element-201" />
        </button>
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xop1kjUZWavx3D9YfBpk26/eugenio.png" alt="User Profile" className="w-8 h-8 sm:w-10 sm:h-10 rounded-full object-cover" data-id="element-202" />
      </div>
    </div>;
}